import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { SingleProjectToTargetComponentBase } from 'common-ui';

@Component({
  selector: 'ideal-render-target-product-result-image-overlay',
  standalone: true,
  imports: [],
  template: ``,
  styles: `
    :host {
      position: absolute;
      top: 0;
      left: 0;
      max-width: 100%;
      padding: 0.25em;
      z-index: 10;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 0.5em;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductResultImageOverlayRenderTargetComponent extends SingleProjectToTargetComponentBase {
  public override readonly context = undefined;
  protected readonly renderInElements = computed(() => this.renderNodes().map((node) => this.element));
}
